import { render, staticRenderFns } from "./AddLoan.vue?vue&type=template&id=6ea9bebe"
import script from "./AddLoan.vue?vue&type=script&lang=js"
export * from "./AddLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports